/*
  ExerciseProgramTemplatesCard — Settings entry-point for the same
  Exercise Program templates library operators can reach from any
  client's Programs tab. Kept as a thin launcher over the existing
  TemplateManageDialog so there's one canonical editor to maintain.
*/
import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Wand2, Dumbbell } from "lucide-react";
import TemplateManageDialog from "@/components/TemplateManageDialog";

export default function ExerciseProgramTemplatesCard() {
  const [open, setOpen] = useState(false);
  return (
    <Card className="p-4 rounded-lg border border-zinc-200 shadow-none"
          data-testid="exercise-program-templates-card">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-3">
          <div className="p-2 rounded-md bg-indigo-50 border border-indigo-200 text-indigo-800">
            <Dumbbell className="h-4 w-4" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider text-zinc-500 font-semibold">
              Exercise Program Templates
            </div>
            <div className="text-sm text-zinc-600 leading-relaxed">
              Edit any program template's sections, exercises, precautions
              and defaults. Changes apply to future programs instantiated
              from the template — existing client programs are unaffected.
            </div>
          </div>
        </div>
        <Button size="sm"
                onClick={() => setOpen(true)}
                className="bg-indigo-600 hover:bg-indigo-700 text-white whitespace-nowrap"
                data-testid="settings-manage-ep-templates">
          <Wand2 className="h-3.5 w-3.5 mr-1" /> Edit templates
        </Button>
      </div>
      <TemplateManageDialog open={open} onOpenChange={setOpen} />
    </Card>
  );
}
